import React, { PropsWithChildren } from 'react'

// types
import { ContextProps } from '../types/types'

// utils
import { homePageQuerySchema } from '../utils/zodQuerySchemas'

// components
import HomePage from '../pages/HomePage/HomePage'

// hooks
import useZodQueryParams from '../hooks/useZodQueryParams'
import { getValidHomePageQuery } from '../utils/helper'

type SalonsRouteProps = PropsWithChildren<ContextProps & {}>

const HomePageRoute: React.FC<SalonsRouteProps> = (props) => {
	const [query, setQuery] = useZodQueryParams(homePageQuerySchema)

	const validQuery = getValidHomePageQuery(query)

	return <HomePage {...props} query={validQuery} setQuery={setQuery} />
}

export default HomePageRoute
